import { Habilitation, HABILITATION_I18N } from '@pflegia/types/api/general/habilitation';
import { formatNameWithTitles as baseFormatNameWithTitles } from '@pflegia/util/common/format-name';

export const formatNameWithTitles = baseFormatNameWithTitles<Habilitation>(HABILITATION_I18N);
